module.exports = __webpack_public_path__ + "img/WELDING_WELD.0e3c4e15.jpg";